












































































































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class SideBar extends Vue {
  @Prop() addExpenseAction: (event?: any) => void;
  @Prop() displayPersonalExpenseTracker: boolean;
  @Prop() showMyExpensesHowItWorks: boolean;
  @Prop() showFindExpensesHowItWorks: boolean;
  @Prop({ default: true })
  showAddExpense: boolean;

  custodianSettingsStore = useCustodianSettingsStore();

  fullView = true;

  onClick (): void {
    this.fullView = !this.fullView;
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }
}
